import { environment } from "../../../../environments/environment"

export const urlAuth = environment.apiService_Auth
export const urlErp = environment.apiService_Erp
export const urlReport = environment.apiService_Report
export const urlAdjuntos = environment.apiService_Adjuntos
export const urlFE = environment.apiService_FE